import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Logger } from '@app/core';
import { FilterService } from '@progress/kendo-angular-grid';
import { FormBuilder } from '@angular/forms';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';

const log = new Logger('KendoClientSelectComponent');

@Component({
  selector: 'app-kendo-client-select',
  templateUrl: './kendo-client-select.component.html',
  styleUrls: ['./kendo-client-select.component.scss'],
})
export class KendoClientSelectComponent extends CustomKendoFilter implements OnInit, OnChanges {
  @Input() field = 'client_id';
  @Input() isInModal = true;

  constructor(private formBuilder: FormBuilder, filterService: FilterService) {
    super(filterService);
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      client_id: [null],
      client: [null],
    });

    const client = this.getObjectFromStorage(this.field, 'clients');

    if (client) {
      setTimeout(() => {
        this.form.patchValue({
          client: client,
          client_id: client.id,
        });
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // Изчиства формата
    // Използва се, за да чисти филтрите, когато се сетне null state на таблицата
    if (this.form && changes && changes.filter && !changes.filter.currentValue) {
      this.form.reset();
    }
  }

  onSelect(event: any) {
    CustomKendoFilter.pushObjectInStorage(event, 'clients');

    this.filter = this.removeFilter(this.field);

    const filters = [];
    if (event) {
      filters.push({
        field: this.field,
        operator: 'eq',
        value: event.id,
      });
    }

    const root = this.filter || {
      logic: 'and',
      filters: [],
    };

    if (filters.length) {
      root.filters.push(...filters);
    }
    this.filterService.filter(root);
    log.debug('filters', filters);
  }
}
